import { defineModal, Modal } from '@libs/ui/ds'
import { FlipperFlagCondition } from '@spa/features'
import type { FC } from 'react'
import React from 'react'

import { RealHoursContainer } from './RealHoursContainer'
import { RealHoursContainerLegacy } from './RealHoursContainerLegacy'

export type RealHoursModalProps = {
  shiftId: number
  weeklyscheduleId: number
  membershipId: number
  setDidNotShow?: boolean
  precomputedCanValidate?: boolean // Month View V2 already have this information
  onSuccess?: () => void
}
export const realHoursModalDef = defineModal<RealHoursModalProps>({
  name: 'realHoursModal'
})

const RealHoursModal: FC = () => {
  const { close, isOpen, data } = realHoursModalDef.useModal()

  if (!data) {
    return null
  }

  return (
    <Modal opened={isOpen} onClose={close} variant='right'>
      <FlipperFlagCondition
        flag='scheduling_burning_redux'
        active={<RealHoursContainer modalData={data} closeModal={close} />}
        inactive={
          <RealHoursContainerLegacy modalData={data} closeModal={close} />
        }
      />
    </Modal>
  )
}

export default realHoursModalDef.withModalShow(RealHoursModal)
